import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`My working & working out device...`}</p>
    {/* try to keep no politics ok? */}
    {/* # Congrats to Winner 🎉🎉🎉 */}
    {/* Today finally United States has decided its next 4 year's path. Hope this path will be better for pandemic control, science, understanding and peace of world. People all over the world need get together to fight the COVID-19 and climate crisis for next generation. At the moment when I heard `united`, I was somewhat touched. I know rocky way ahead, but let's hope and aim the best 🙏. 2020 will soon be the past. */}
    <h1>{`Standup Desk?`}</h1>
    <p>{`No. If you want to burn more calories in this pandemic age, better solution is biking desk! Recently I'm loving this biking desk from `}<a parentName="p" {...{
        "href": "https://www.amazon.com/gp/product/B0762FFNQ4"
      }}>{`Flexispot`}</a>{`. Working while draining massive calories! Keep fit and healthy! Undoubtably 5 stars was given on Amazon review and I bought 2. In ~3 mo, I burnt 30 pound and that's incredible! I think in this way, I'm 10% ready for Mars immigration.
`}<figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "width": "40%",
          "textAlign": "center",
          "minWidth": "7rem",
          "backgroundColor": "rgb(255, 255, 255)",
          "border": "1px solid rgb(222, 226, 230)",
          "maxWidth": "600px"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "487px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "105.33333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAIAAADJt1n/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFDElEQVQ4ywEBBf76AOPCmdy8ldy8ldi5ktW2kdK0j86xjcqujMarisOpir+oibyliLyoioRjTSYYExYXFmVQPIZjQHZWM2hDJADRs47nxp3dvJfbu5fXuJTUtpLRs5HNsY/Jro3FrIzCqozBq422noOca1FrQTEuHBdDOCyQbEh6WDduSysAdmZjyauI5cSe27uX17mW1beU0rWTzrKRzLCPyK6PxKuNxK6Rt5yCpmtOkl1EZUQ2Y1JCk3FOflw6d1QzAGFXa29fXsCkhd2/mta4ltW3ldK1lM6zksywksmvkcatj8OskbmghIdjTHlMMpdvV3doaIp6cYZkQnxZOABeVGFVS1qQfGrdvprTtpXUt5XStZPPs5LMsZLJsJHGr5HErZK7pIi/rJKafWRbQzt1a257d4GAaViAYj0AYE5XTkBJm4Vw3L6bz7SU0baU0LSTzrKTzLGQyrCRx6+Txa6TwauQyLGYhnRnWklGhnp9e3aCZ11Zclc2AFZGTks+QqePdti7mc2wkM6wkMqujMmti8itjMivkMmwk8auk8Svlbynj35lVreKc5NzZjg0OWdjam9XPABLPUBNPj6wlXfQsY3HqIXGp4LEpYDFpoPGq4nIro7GsJHGsZXJrpLClnesdVSlclpeS0kfHiJdWGOAb2AALCIeSTozvJ58yamDwqN8xKR6x6h/yquGxJ9+0KWK1rCTyZ1/uIRmiVtBYEM0QC0mPjY4REJLSkZQlI2JAFtHOHNcSM2rhcWlfsWmgsWpi8OnipyHdI5zZbGPgLWUgpV2Z39oWoZ0ZXpsYDYrKEQ5N05MVkpHUYR+gACBaVmVemLMqX/GpXyihmlvWklVQzdTQjVdSjhpVUJbSTdIPC5YSTu4pIucjHo8LysjGhdHQ0phXWdvZ2sAdF1Nq5F80rSQwaF5r49qlXhXgGVHYUkxY0s0Uj4qXUk0hHBakIFvqJmEnI19LSckEA0KIhwaUEtSaWJoAHphUejOwOLJuK+Qa7mYcKyLYmFILkQwG1pEL088KUw8KmldTXdtX3txZ0hAOx4ZGSgiJB8cHSQiKEk+OgCNc2bjy7/FrZyRc0+2lWudfFZKNR42JhVbRTFVQjBPQDBSRjw9NjIuJiYmISEiGxkgGxsjICElJCg6LysAuJuK1rmpsJeJe2BGpYRgon9aVz4nNSUUX0k2Tj4wMSciJBwdGxYVGBMRGxgXExAODgwMDgwMFRITPy8hAEg/OjIrKSwlJDAlH0UzJW5UOmFJLzAhEmNPQEU3MCMcGx4aGhENDgwKCg4MDC0oJDAnIDMpIkw+Mk43JAAAAAEDAwIAAQEQDQsYEQ0uIhdjSi9ENCaVeGNINysQDQwdGRoaGBsWEhFPRz55bGFgSzyDbWB6Y1NNMx4AGBMOIxkSEA0KEQ0LHxYPGhINWkEpe2RQtpiAjHJfPTEoFxMRIiAlRTgxblVFa1REeWRVqJeUd2FVSS8ZABQPCyMYEBQOCw8MCSQaEQ4KB0czH6eMc8Glj6WIcV9LPBIODRYUF0pBP4JvYX9qWpiBdLGdmWVMO0YuGQAbEw0jGRAVDwsMCggmHBMMCgY2JhmihnDAoIhzXEoGBQUYExESDw0ZFxpZUkt4alqgiHm8ppxeRzVLMiAAHhYPIhgRFA8LCgkIIRkRFQ8KMiUapIl0uZyGs5iCrpSAloFyOzMwEg8PW1VYj4B7t52OwqqgdFpMZEg3UR/+8ERcNQAAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Bike @ Home",
            "title": "Bike @ Home",
            "src": "/static/102066aaf4a00b38452b3af7ea604d05/7b439/bike-wfh.png",
            "srcSet": ["/static/102066aaf4a00b38452b3af7ea604d05/8a4e8/bike-wfh.png 150w", "/static/102066aaf4a00b38452b3af7ea604d05/5a46d/bike-wfh.png 300w", "/static/102066aaf4a00b38452b3af7ea604d05/7b439/bike-wfh.png 487w"],
            "sizes": "(max-width: 487px) 100vw, 487px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Bike @ Home`}</figcaption>{`
  `}</figure></p>
    <p>{`With VR, this bike at home idea probably could get more interesting for space station motion sickness training 😂.`}</p>
    <h1>{`Durability`}</h1>
    <p>{`Even though officially they don't recommend this as workout bike (what? 😂), the durability is a problem if you like to burn calories everyday. After ~6 mo intensive biking, my first one broke: the belt cannot last long. `}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/552505dc441c12c3c66bc95626173f8a/d2602/bike-wfh-broken1.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwAB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgH/2gAMAwEAAhADEAAAAVzGKOKp/8QAGxAAAgIDAQAAAAAAAAAAAAAAAQIAAxESFCL/2gAIAQEAAQUC6BGuTAsUgJ5KiarP/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8BZ//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/ASf/xAAZEAACAwEAAAAAAAAAAAAAAAAAARExMhL/2gAIAQEABj8Cl0WbRyUjKP/EAB0QAQACAgIDAAAAAAAAAAAAAAEAESFBMXGBodH/2gAIAQEAAT8hKTkbqaidkOPtjoBmtw3wmRtPE//aAAwDAQACAAMAAAAQ5x//xAAWEQADAAAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8QGL//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/EB//xAAbEAEBAQACAwAAAAAAAAAAAAABEQAhMUFRkf/aAAgBAQABPxAJHiCjnVUBLWMZPjMQ3sRDPb1l5ZOFnTBoe07/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Broken Belt",
            "title": "Broken Belt",
            "src": "/static/552505dc441c12c3c66bc95626173f8a/b4294/bike-wfh-broken1.jpg",
            "srcSet": ["/static/552505dc441c12c3c66bc95626173f8a/75985/bike-wfh-broken1.jpg 150w", "/static/552505dc441c12c3c66bc95626173f8a/f93b5/bike-wfh-broken1.jpg 300w", "/static/552505dc441c12c3c66bc95626173f8a/b4294/bike-wfh-broken1.jpg 600w", "/static/552505dc441c12c3c66bc95626173f8a/8e1fc/bike-wfh-broken1.jpg 900w", "/static/552505dc441c12c3c66bc95626173f8a/e5166/bike-wfh-broken1.jpg 1200w", "/static/552505dc441c12c3c66bc95626173f8a/d2602/bike-wfh-broken1.jpg 4032w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Broken Belt`}</figcaption>{`
  `}</figure>
    <p>{`The solution is to open it and replace the belt. Not an easy path and I need bike tool like `}<a parentName="p" {...{
        "href": "https://www.amazon.com/gp/product/B087FWSHG5"
      }}>{`this`}</a>{` and tons of strength (weight training 🤔) to remove the bike crank. Of course I need to buy replacement belt, however, the one with exact ribs is not available so I customized it by cutting `}<a parentName="p" {...{
        "href": "https://www.amazon.com/gp/product/B00CJK78Z4"
      }}>{`this`}</a>{` 10 ribs belt.`}</p>
    <p>{`After a lot of unscrewing and cut the old belt, I came to actually install the new belt.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d24cefe3548894cdce89094ede9087b3/d2602/bike-wfh-broken2.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMBBP/EABYBAQEBAAAAAAAAAAAAAAAAAAIBA//aAAwDAQACEAMQAAAB5q2G6iGn/8QAGhABAAMAAwAAAAAAAAAAAAAAAQACEQMTIv/aAAgBAQABBQLlduT1K3UW29rP/8QAFxEBAAMAAAAAAAAAAAAAAAAAAAIRE//aAAgBAwEBPwGmcn//xAAXEQADAQAAAAAAAAAAAAAAAAAAARES/9oACAECAQE/AajSP//EAB4QAAEBCQAAAAAAAAAAAAAAAAACARARITFBYZHh/9oACAEBAAY/AooS3JTZJ1jh/8QAGhAAAwEBAQEAAAAAAAAAAAAAAAERITFBUf/aAAgBAQABPyFinOTHRIm6nrQ4U5PpURQiRYL9aTH/2gAMAwEAAgADAAAAEOQf/8QAFhEBAQEAAAAAAAAAAAAAAAAAABFB/9oACAEDAQE/EKUx/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAFh/9oACAECAQE/EKtH/8QAHBABAQACAgMAAAAAAAAAAAAAAREAITFBYYHB/9oACAEBAAE/EFZajGkOveagUhTTfG+/GURtSVEyEnSEOTGNAGa7yhimJt9z/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Install New Belt",
            "title": "Install New Belt",
            "src": "/static/d24cefe3548894cdce89094ede9087b3/b4294/bike-wfh-broken2.jpg",
            "srcSet": ["/static/d24cefe3548894cdce89094ede9087b3/75985/bike-wfh-broken2.jpg 150w", "/static/d24cefe3548894cdce89094ede9087b3/f93b5/bike-wfh-broken2.jpg 300w", "/static/d24cefe3548894cdce89094ede9087b3/b4294/bike-wfh-broken2.jpg 600w", "/static/d24cefe3548894cdce89094ede9087b3/8e1fc/bike-wfh-broken2.jpg 900w", "/static/d24cefe3548894cdce89094ede9087b3/e5166/bike-wfh-broken2.jpg 1200w", "/static/d24cefe3548894cdce89094ede9087b3/d2602/bike-wfh-broken2.jpg 4032w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Install New Belt`}</figcaption>{`
  `}</figure>
    <p>{`The trick is to partially put belt on track and carefully `}<em parentName="p">{`rotate`}</em>{` the wheel so that the belt will latch on perfectly. Unfortunately I didn't have any footage when I fixed this bike. So next year when it brokes, I'll record everything to share.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      